import Backbone from 'backbone'
import _ from 'lodash'
import SlideForm from './slide-form'
import MarkedField from 'scoreboard/components/marked-field'
import i18n from 'scoreboard/components/i18n'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import httpsValidator from 'scoreboard/components/validators/https-validator'

// A form to edit slides which contain links to external websides (#17066, #27839)

var ExternalSlideForm = SlideForm.extend({

	// this.model is a Slide

	className: 'slide-form external-slide-form',

	render: function() {
		SlideForm.prototype.render.apply(this, arguments)
		// Edit the overview to suit the external slide properties which can be edited
		this.$('.period-panel').remove()
		var webAddressInput =
			`<div class="web-address">
				<label class="full-width">
					<span class="label-text">
						${i18n.get('relatedItems.webAddress')}
					</span>
					<input type="text" name="url">
				</label>
			</div>`
		this.$('.panel-content').append(webAddressInput)
		this.webAddressField = new MarkedField({
			el: this.$('[name=url]'),
			validator: [requiredValidator, httpsValidator]
		}).render()

		this.writeToDom()
		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		SlideForm.prototype.remove.apply(this, arguments)
		_.invokeMap([this.webAddressField], 'remove')
	}
})

export default ExternalSlideForm

ExternalSlideForm.__filename__ = 'briefings/external-slide-form.js'
